export var FaqCategory;
(function (FaqCategory) {
    FaqCategory["SystemUser"] = "System & User";
    FaqCategory["Usage"] = "Usage";
    FaqCategory["Maintenance"] = "Maintenance";
    FaqCategory["Facility"] = "Facility";
    FaqCategory["Dashboard"] = "Dashboard";
})(FaqCategory || (FaqCategory = {}));
//# sourceMappingURL=faqCategory.enum.js.map